import script from "./gene_detail.vue?vue&type=script&setup=true&lang=js"
export * from "./gene_detail.vue?vue&type=script&setup=true&lang=js"

import "./gene_detail.vue?vue&type=style&index=0&id=32fe3f5c&scoped=true&lang=css"

import exportComponent from "D:\\Desktop\\项目\\xiongxi\\vue-notus-main\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32fe3f5c"]])

export default __exports__